import { render } from "./LogoBanner.vue?vue&type=template&id=1c0ec832"
const script = {}
script.render = render

export default script